module.exports = {"500104001":"新山村街道","500104002":"跃进村街道","500104003":"九宫庙街道","500104004":"茄子溪街道","500104005":"春晖路街道","500104101":"八桥镇","500104102":"建胜镇","500104103":"跳磴镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500104.json
// module id = 2215
// module chunks = 0